<template>
  <div class="text-center ma-2">
    <v-snackbar v-model="show" :color="color">
      {{ text }}

      <template v-slot:action="{ attrs }">
        <v-btn
            color="pink"
            text
            v-bind="attrs"
            @click="show=false"
        >
          Kapat
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
export default {
name: "mySnackbar",
  data () {
    return{
      color: 'error',
      text: '',
      show: false,
    }
  },

  methods: {
    raiseError(message=''){
      if(message.includes("You do not have permission")){
        this.$store.commit('LOGOUT_USER')
        this.$router.push('/')
      }
      else{
        this.text = "Hata: " + message;
        this.color = "error"
        this.show = true
      }

    },
    raiseSuccess(message=''){
      this.text = message;
      this.color = "success"
      this.show = true
    }
  }
}
</script>

<style scoped>

</style>
